import type { FaireProductEntity } from "../../entity_types/product";

export const p_622p87xifz: FaireProductEntity = {
  token: "p_622p87xifz",
  type: "product",
  name: "INFUSE - Mezcal & tequila infusion and tasting kit",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/9e529e7b73e9e7ec716575a21c143de63481c91b53d10fef8c51a8c68e3bf55c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/392a334ca8e699e2e2cabe3746ccc5cb214d7bfb0be0572683da7e7abd1b6f29.jpeg",
    "https://cdn.faire.com/fastly/4403744225b3d6193b7b45fd5fe3893ddcc60bfbe63f1d2e5e5fc831e6c0723d.jpeg",
    "https://cdn.faire.com/fastly/6425120eb465c2aa1a5e68713c469e3a05c8faeb335da8c558fc9db02cf0ec16.jpeg",
    "https://cdn.faire.com/fastly/a88e979105b3a8db711990149f918c42be601621ca41dd366130b2ca3193ec8e.jpeg",
    "https://cdn.faire.com/fastly/f1b5d32d25342d10d6d581bc990e511ed73fc4d8191880a6358fb3ae6d9e8d7c.jpeg",
    "https://cdn.faire.com/fastly/f417c240efd5daad4525c10a56d4b1464cac15a778078a72161f5e2058457d29.jpeg",
    "https://cdn.faire.com/fastly/78acfa2f6128da271d79175b77d2ea7d69cc198e367d925250f7202388b673a5.jpeg",
  ],
  priceDollars: 70,
  description:
    "As tequila and mezcal's popularity soars, explore the art of flavor experimentation with our Infuse Set. Embrace tradition with four jicaras - small cups crafted from jicara fruit bark, designed to enhance the full expression of mezcal by allowing alcohol to evaporate. These handblown glass-tasting cups feature wide mouths, ensuring maximum flavor absorption. The set also includes a wide-top decanter with a robust cork seal, preserving your creations perfectly. Delight in the world of mezcal with our Infuse Set, which comes with recipes and an elegant gift box. Elevate your tasting experience now!",
  tags: [],
  msrpDollars: 140,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:22.002Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
